<div class="h-100" >
  <div class="shadow-sm bg-white rounded-lg d-flex align-items-start justify-content-center p-3 h-100 emptyScreen">
    <div class="text-center" style="margin-top:80px" *ngIf="displayPage">
      <h5 class="mb-5">Connect your work email</h5>
      <p class="pb-5">
        Webbtree abides by a strict security and privacy policy.<br />Only emails created in Webbtree can be read and sent.
      </p>
      <div class="d-flex justify-content-center flex-column" style="row-gap: 1rem;">
        <app-email-campaign-outlook-button (outlookConnect)="onOutlookConnect($event)"></app-email-campaign-outlook-button>
        <app-email-campaign-google-button (gmailConnect)="onGmailConnect($event)"></app-email-campaign-google-button>
      </div>
    </div>
  </div>
</div>


<ngb-alert class="ngb-alert" *ngIf="warningMessage" type="warning" (close)="warningMessage = ''">
  <span class="warningmsg"> 
    <i style="color: #FF9B05;" class="fa-sharp-duotone fa-light fa-circle-exclamation mr-1"></i>
    Oops! Something went wrong. Please contact us at 
    support&#64;webbtree.com for assistance.
  </span>
</ngb-alert>
